import { render, staticRenderFns } from "./oddsItem.vue?vue&type=template&id=5836b985&lang=pug&"
import script from "./oddsItem.vue?vue&type=script&lang=js&"
export * from "./oddsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports